@file:OptIn(org.jetbrains.compose.resources.InternalResourceApi::class)

package songwritersnotebookapp.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi

private object CommonMainDrawable0 {
  public val compose_multiplatform: DrawableResource by 
      lazy { init_compose_multiplatform() }

  public val feature_ai: DrawableResource by 
      lazy { init_feature_ai() }

  public val feature_ai_assistance: DrawableResource by 
      lazy { init_feature_ai_assistance() }

  public val feature_chords: DrawableResource by 
      lazy { init_feature_chords() }

  public val feature_cloud_sync: DrawableResource by 
      lazy { init_feature_cloud_sync() }

  public val feature_collaboration: DrawableResource by 
      lazy { init_feature_collaboration() }

  public val feature_custom_chords: DrawableResource by 
      lazy { init_feature_custom_chords() }

  public val feature_editor: DrawableResource by 
      lazy { init_feature_editor() }

  public val feature_export: DrawableResource by 
      lazy { init_feature_export() }

  public val feature_guitar_tabs: DrawableResource by 
      lazy { init_feature_guitar_tabs() }

  public val feature_img_1: DrawableResource by 
      lazy { init_feature_img_1() }

  public val feature_img_10: DrawableResource by 
      lazy { init_feature_img_10() }

  public val feature_img_11: DrawableResource by 
      lazy { init_feature_img_11() }

  public val feature_img_2: DrawableResource by 
      lazy { init_feature_img_2() }

  public val feature_img_3: DrawableResource by 
      lazy { init_feature_img_3() }

  public val feature_img_4: DrawableResource by 
      lazy { init_feature_img_4() }

  public val feature_img_5: DrawableResource by 
      lazy { init_feature_img_5() }

  public val feature_img_6: DrawableResource by 
      lazy { init_feature_img_6() }

  public val feature_img_7: DrawableResource by 
      lazy { init_feature_img_7() }

  public val feature_img_8: DrawableResource by 
      lazy { init_feature_img_8() }

  public val feature_img_9: DrawableResource by 
      lazy { init_feature_img_9() }

  public val feature_lyric_engine: DrawableResource by 
      lazy { init_feature_lyric_engine() }

  public val feature_recordings: DrawableResource by 
      lazy { init_feature_recordings() }

  public val feature_smart_writing: DrawableResource by 
      lazy { init_feature_smart_writing() }

  public val feature_studio: DrawableResource by 
      lazy { init_feature_studio() }

  public val feature_studio_arrangement: DrawableResource by 
      lazy { init_feature_studio_arrangement() }

  public val feature_tabs: DrawableResource by 
      lazy { init_feature_tabs() }

  public val feature_version_history: DrawableResource by 
      lazy { init_feature_version_history() }

  public val feature_writing: DrawableResource by 
      lazy { init_feature_writing() }

  public val ic_bass: DrawableResource by 
      lazy { init_ic_bass() }

  public val ic_drum: DrawableResource by 
      lazy { init_ic_drum() }

  public val ic_google: DrawableResource by 
      lazy { init_ic_google() }

  public val ic_guitar: DrawableResource by 
      lazy { init_ic_guitar() }

  public val ic_logo_fg: DrawableResource by 
      lazy { init_ic_logo_fg() }

  public val ic_rewind: DrawableResource by 
      lazy { init_ic_rewind() }
}

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("compose_multiplatform", CommonMainDrawable0.compose_multiplatform)
  map.put("feature_ai", CommonMainDrawable0.feature_ai)
  map.put("feature_ai_assistance", CommonMainDrawable0.feature_ai_assistance)
  map.put("feature_chords", CommonMainDrawable0.feature_chords)
  map.put("feature_cloud_sync", CommonMainDrawable0.feature_cloud_sync)
  map.put("feature_collaboration", CommonMainDrawable0.feature_collaboration)
  map.put("feature_custom_chords", CommonMainDrawable0.feature_custom_chords)
  map.put("feature_editor", CommonMainDrawable0.feature_editor)
  map.put("feature_export", CommonMainDrawable0.feature_export)
  map.put("feature_guitar_tabs", CommonMainDrawable0.feature_guitar_tabs)
  map.put("feature_img_1", CommonMainDrawable0.feature_img_1)
  map.put("feature_img_10", CommonMainDrawable0.feature_img_10)
  map.put("feature_img_11", CommonMainDrawable0.feature_img_11)
  map.put("feature_img_2", CommonMainDrawable0.feature_img_2)
  map.put("feature_img_3", CommonMainDrawable0.feature_img_3)
  map.put("feature_img_4", CommonMainDrawable0.feature_img_4)
  map.put("feature_img_5", CommonMainDrawable0.feature_img_5)
  map.put("feature_img_6", CommonMainDrawable0.feature_img_6)
  map.put("feature_img_7", CommonMainDrawable0.feature_img_7)
  map.put("feature_img_8", CommonMainDrawable0.feature_img_8)
  map.put("feature_img_9", CommonMainDrawable0.feature_img_9)
  map.put("feature_lyric_engine", CommonMainDrawable0.feature_lyric_engine)
  map.put("feature_recordings", CommonMainDrawable0.feature_recordings)
  map.put("feature_smart_writing", CommonMainDrawable0.feature_smart_writing)
  map.put("feature_studio", CommonMainDrawable0.feature_studio)
  map.put("feature_studio_arrangement", CommonMainDrawable0.feature_studio_arrangement)
  map.put("feature_tabs", CommonMainDrawable0.feature_tabs)
  map.put("feature_version_history", CommonMainDrawable0.feature_version_history)
  map.put("feature_writing", CommonMainDrawable0.feature_writing)
  map.put("ic_bass", CommonMainDrawable0.ic_bass)
  map.put("ic_drum", CommonMainDrawable0.ic_drum)
  map.put("ic_google", CommonMainDrawable0.ic_google)
  map.put("ic_guitar", CommonMainDrawable0.ic_guitar)
  map.put("ic_logo_fg", CommonMainDrawable0.ic_logo_fg)
  map.put("ic_rewind", CommonMainDrawable0.ic_rewind)
}

internal val Res.drawable.compose_multiplatform: DrawableResource
  get() = CommonMainDrawable0.compose_multiplatform

private fun init_compose_multiplatform(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:compose_multiplatform",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/songwritersnotebookapp.composeapp.generated.resources/drawable/compose-multiplatform.xml", -1, -1),
    )
)

internal val Res.drawable.feature_ai: DrawableResource
  get() = CommonMainDrawable0.feature_ai

private fun init_feature_ai(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:feature_ai",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/songwritersnotebookapp.composeapp.generated.resources/drawable/feature_ai.png", -1, -1),
    )
)

internal val Res.drawable.feature_ai_assistance: DrawableResource
  get() = CommonMainDrawable0.feature_ai_assistance

private fun init_feature_ai_assistance(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:feature_ai_assistance",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/songwritersnotebookapp.composeapp.generated.resources/drawable/feature_ai_assistance.webp", -1, -1),
    )
)

internal val Res.drawable.feature_chords: DrawableResource
  get() = CommonMainDrawable0.feature_chords

private fun init_feature_chords(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:feature_chords",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/songwritersnotebookapp.composeapp.generated.resources/drawable/feature_chords.png", -1, -1),
    )
)

internal val Res.drawable.feature_cloud_sync: DrawableResource
  get() = CommonMainDrawable0.feature_cloud_sync

private fun init_feature_cloud_sync(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:feature_cloud_sync",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/songwritersnotebookapp.composeapp.generated.resources/drawable/feature_cloud_sync.webp", -1, -1),
    )
)

internal val Res.drawable.feature_collaboration: DrawableResource
  get() = CommonMainDrawable0.feature_collaboration

private fun init_feature_collaboration(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:feature_collaboration",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/songwritersnotebookapp.composeapp.generated.resources/drawable/feature_collaboration.webp", -1, -1),
    )
)

internal val Res.drawable.feature_custom_chords: DrawableResource
  get() = CommonMainDrawable0.feature_custom_chords

private fun init_feature_custom_chords(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:feature_custom_chords",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/songwritersnotebookapp.composeapp.generated.resources/drawable/feature_custom_chords.webp", -1, -1),
    )
)

internal val Res.drawable.feature_editor: DrawableResource
  get() = CommonMainDrawable0.feature_editor

private fun init_feature_editor(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:feature_editor",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/songwritersnotebookapp.composeapp.generated.resources/drawable/feature_editor.png", -1, -1),
    )
)

internal val Res.drawable.feature_export: DrawableResource
  get() = CommonMainDrawable0.feature_export

private fun init_feature_export(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:feature_export",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/songwritersnotebookapp.composeapp.generated.resources/drawable/feature_export.png", -1, -1),
    )
)

internal val Res.drawable.feature_guitar_tabs: DrawableResource
  get() = CommonMainDrawable0.feature_guitar_tabs

private fun init_feature_guitar_tabs(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:feature_guitar_tabs",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/songwritersnotebookapp.composeapp.generated.resources/drawable/feature_guitar_tabs.webp", -1, -1),
    )
)

internal val Res.drawable.feature_img_1: DrawableResource
  get() = CommonMainDrawable0.feature_img_1

private fun init_feature_img_1(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:feature_img_1",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/songwritersnotebookapp.composeapp.generated.resources/drawable/feature_img_1.webp", -1, -1),
    )
)

internal val Res.drawable.feature_img_10: DrawableResource
  get() = CommonMainDrawable0.feature_img_10

private fun init_feature_img_10(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:feature_img_10",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/songwritersnotebookapp.composeapp.generated.resources/drawable/feature_img_10.webp", -1, -1),
    )
)

internal val Res.drawable.feature_img_11: DrawableResource
  get() = CommonMainDrawable0.feature_img_11

private fun init_feature_img_11(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:feature_img_11",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/songwritersnotebookapp.composeapp.generated.resources/drawable/feature_img_11.webp", -1, -1),
    )
)

internal val Res.drawable.feature_img_2: DrawableResource
  get() = CommonMainDrawable0.feature_img_2

private fun init_feature_img_2(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:feature_img_2",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/songwritersnotebookapp.composeapp.generated.resources/drawable/feature_img_2.webp", -1, -1),
    )
)

internal val Res.drawable.feature_img_3: DrawableResource
  get() = CommonMainDrawable0.feature_img_3

private fun init_feature_img_3(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:feature_img_3",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/songwritersnotebookapp.composeapp.generated.resources/drawable/feature_img_3.webp", -1, -1),
    )
)

internal val Res.drawable.feature_img_4: DrawableResource
  get() = CommonMainDrawable0.feature_img_4

private fun init_feature_img_4(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:feature_img_4",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/songwritersnotebookapp.composeapp.generated.resources/drawable/feature_img_4.webp", -1, -1),
    )
)

internal val Res.drawable.feature_img_5: DrawableResource
  get() = CommonMainDrawable0.feature_img_5

private fun init_feature_img_5(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:feature_img_5",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/songwritersnotebookapp.composeapp.generated.resources/drawable/feature_img_5.webp", -1, -1),
    )
)

internal val Res.drawable.feature_img_6: DrawableResource
  get() = CommonMainDrawable0.feature_img_6

private fun init_feature_img_6(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:feature_img_6",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/songwritersnotebookapp.composeapp.generated.resources/drawable/feature_img_6.webp", -1, -1),
    )
)

internal val Res.drawable.feature_img_7: DrawableResource
  get() = CommonMainDrawable0.feature_img_7

private fun init_feature_img_7(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:feature_img_7",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/songwritersnotebookapp.composeapp.generated.resources/drawable/feature_img_7.webp", -1, -1),
    )
)

internal val Res.drawable.feature_img_8: DrawableResource
  get() = CommonMainDrawable0.feature_img_8

private fun init_feature_img_8(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:feature_img_8",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/songwritersnotebookapp.composeapp.generated.resources/drawable/feature_img_8.webp", -1, -1),
    )
)

internal val Res.drawable.feature_img_9: DrawableResource
  get() = CommonMainDrawable0.feature_img_9

private fun init_feature_img_9(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:feature_img_9",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/songwritersnotebookapp.composeapp.generated.resources/drawable/feature_img_9.webp", -1, -1),
    )
)

internal val Res.drawable.feature_lyric_engine: DrawableResource
  get() = CommonMainDrawable0.feature_lyric_engine

private fun init_feature_lyric_engine(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:feature_lyric_engine",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/songwritersnotebookapp.composeapp.generated.resources/drawable/feature_lyric_engine.webp", -1, -1),
    )
)

internal val Res.drawable.feature_recordings: DrawableResource
  get() = CommonMainDrawable0.feature_recordings

private fun init_feature_recordings(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:feature_recordings",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/songwritersnotebookapp.composeapp.generated.resources/drawable/feature_recordings.webp", -1, -1),
    )
)

internal val Res.drawable.feature_smart_writing: DrawableResource
  get() = CommonMainDrawable0.feature_smart_writing

private fun init_feature_smart_writing(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:feature_smart_writing",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/songwritersnotebookapp.composeapp.generated.resources/drawable/feature_smart_writing.webp", -1, -1),
    )
)

internal val Res.drawable.feature_studio: DrawableResource
  get() = CommonMainDrawable0.feature_studio

private fun init_feature_studio(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:feature_studio",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/songwritersnotebookapp.composeapp.generated.resources/drawable/feature_studio.png", -1, -1),
    )
)

internal val Res.drawable.feature_studio_arrangement: DrawableResource
  get() = CommonMainDrawable0.feature_studio_arrangement

private fun init_feature_studio_arrangement(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:feature_studio_arrangement",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/songwritersnotebookapp.composeapp.generated.resources/drawable/feature_studio_arrangement.webp", -1, -1),
    )
)

internal val Res.drawable.feature_tabs: DrawableResource
  get() = CommonMainDrawable0.feature_tabs

private fun init_feature_tabs(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:feature_tabs",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/songwritersnotebookapp.composeapp.generated.resources/drawable/feature_tabs.png", -1, -1),
    )
)

internal val Res.drawable.feature_version_history: DrawableResource
  get() = CommonMainDrawable0.feature_version_history

private fun init_feature_version_history(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:feature_version_history",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/songwritersnotebookapp.composeapp.generated.resources/drawable/feature_version_history.webp", -1, -1),
    )
)

internal val Res.drawable.feature_writing: DrawableResource
  get() = CommonMainDrawable0.feature_writing

private fun init_feature_writing(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:feature_writing",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/songwritersnotebookapp.composeapp.generated.resources/drawable/feature_writing.png", -1, -1),
    )
)

internal val Res.drawable.ic_bass: DrawableResource
  get() = CommonMainDrawable0.ic_bass

private fun init_ic_bass(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_bass",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/songwritersnotebookapp.composeapp.generated.resources/drawable/ic_bass.xml", -1, -1),
    )
)

internal val Res.drawable.ic_drum: DrawableResource
  get() = CommonMainDrawable0.ic_drum

private fun init_ic_drum(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_drum",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/songwritersnotebookapp.composeapp.generated.resources/drawable/ic_drum.xml", -1, -1),
    )
)

internal val Res.drawable.ic_google: DrawableResource
  get() = CommonMainDrawable0.ic_google

private fun init_ic_google(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_google",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/songwritersnotebookapp.composeapp.generated.resources/drawable/ic_google.xml", -1, -1),
    )
)

internal val Res.drawable.ic_guitar: DrawableResource
  get() = CommonMainDrawable0.ic_guitar

private fun init_ic_guitar(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_guitar",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/songwritersnotebookapp.composeapp.generated.resources/drawable/ic_guitar.xml", -1, -1),
    )
)

internal val Res.drawable.ic_logo_fg: DrawableResource
  get() = CommonMainDrawable0.ic_logo_fg

private fun init_ic_logo_fg(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_logo_fg",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/songwritersnotebookapp.composeapp.generated.resources/drawable/ic_logo_fg.xml", -1, -1),
    )
)

internal val Res.drawable.ic_rewind: DrawableResource
  get() = CommonMainDrawable0.ic_rewind

private fun init_ic_rewind(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_rewind",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/songwritersnotebookapp.composeapp.generated.resources/drawable/ic_rewind.xml", -1, -1),
    )
)
